/**
 * The accessible name for a `WorkshopList` row's open button.
 *
 * The venue alone is not enough. A teacher's own schedule is usually a single
 * venue repeated down the page, and the date block is decorative to a screen
 * reader (it splits one date across three stylised lines), so a name built
 * from the venue would announce every row of such a list identically. The
 * date and time come from the venue's own wall clock, like everything else
 * the row shows.
 *
 * Each part is dropped when it is missing, so a workshop with no venue name
 * still reads as "Open Thu 20 Sep, 7:30p" rather than "Open ,".
 *
 * The name is built from the workshop, not from what the row happens to be
 * showing: a caller who switches the venue or time off still gets both here.
 * That is deliberate. The switches decide how dense the row looks, and a
 * screen-reader user needs to tell one row from the next either way.
 */
import { formatVenueDate } from '../../../utils/venueTime';

export function workshopListRowLabel(
  venueName: string,
  local: string,
  timeLabel: string,
  cancelled = false,
): string {
  const parts = [venueName.trim(), formatVenueDate(local, 'EEE d MMM', ''), timeLabel.trim()];
  const named = parts.filter((part) => part !== '');
  const verb = cancelled ? 'Open cancelled' : 'Open';
  return named.length > 0 ? `${verb} ${named.join(', ')}` : `${verb} workshop`;
}
